import { render, staticRenderFns } from "./BBoxMap.vue?vue&type=template&id=465ff8bc&scoped=true&"
import script from "./BBoxMap.vue?vue&type=script&lang=js&"
export * from "./BBoxMap.vue?vue&type=script&lang=js&"
import style0 from "./BBoxMap.vue?vue&type=style&index=0&id=465ff8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ff8bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer})
